import { memo } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from 'src/components/buttons';
import { RequireLoginButton } from '../RequireLoginButton';
import { isBookmarkSeclector } from 'src/selectors/user';
import * as UserAction from 'src/redux/actions/user';
import styles from './style.module.scss';

interface IProps {
    className?: string;
    contentId: number;
}

const BookmarkButton = ({ className, contentId }: IProps) => {
    const isBookmark = useSelector(isBookmarkSeclector(contentId));
    const dispatch = useDispatch();

    const handleClick = () => {
        if (contentId) {
            dispatch(UserAction.bookmark(contentId));
        }
    };

    return (
        <RequireLoginButton onClickFn={handleClick}>
            <IconButton
                title="Lưu tin"
                className={cn(styles['btn-bookmark'], className, {
                    [styles['is-bookmark']]: isBookmark,
                })}
                icon="bookmark"
                text={isBookmark ? 'Tin đã được lưu' : 'Lưu tin' }
            />
        </RequireLoginButton>
    );
};

export default memo(BookmarkButton);
